import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { COUNT_MONTH_MPLUS } from 'shared/constants'
import MplusImage from 'shared/icons/mplus_white.webp'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  onClick?: () => void
}

export const OpenMplusButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <div
      className={s.notScoringCard}
      onClick={onClick}
    >
      <h4 className={clsx(s.title, 'semi-bold-13')}>
        {t('mplus.connect_mplus')}
      </h4>

      <div className={s.flexxer}>
        <p className={clsx(s.description, 'regular-11')}>
          {t('mplus.installment', { count: COUNT_MONTH_MPLUS })}
        </p>

        <ImageLazy
          src={MplusImage}
          className={s.icon}
        />
      </div>
    </div>
  )
}
